// API client for interacting with the PHP backend

const API_BASE = '/api';

// Helper function to make API requests
async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(url, config);
    const data = await response.json();
    return { success: response.ok, data, status: response.status };
  } catch (error) {
    console.error('API request failed:', error);
    return { success: false, error: error.message };
  }
}

// --- Professors ---
export const getProfessors = async () => {
  return apiRequest('/professores.php');
};

export const getProfessorById = async (id) => {
  return apiRequest(`/professores.php?id=${encodeURIComponent(id)}`);
};

export const createProfessor = async (data) => {
  return apiRequest('/professores.php', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const updateProfessor = async (id, data) => {
  return apiRequest(`/professores.php?id=${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const deleteProfessor = async (id) => {
  return apiRequest(`/professores.php?id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
};

// --- Students (Enrollments) ---
export const getStudents = async () => {
  return apiRequest('/alunos.php');
};

export const getStudentById = async (id) => {
  return apiRequest(`/alunos.php?id=${encodeURIComponent(id)}`);
};

export const createStudent = async (data) => {
  return apiRequest('/alunos.php', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const updateStudent = async (id, data) => {
  return apiRequest(`/alunos.php?id=${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const deleteStudent = async (id) => {
  return apiRequest(`/alunos.php?id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
};

// --- Auth ---
export const login = async (id, password, profile) => {
  return apiRequest('/auth/login.php', {
    method: 'POST',
    body: JSON.stringify({ id, password, profile }),
  });
};
